/**
 * Footer Selector
 * 
 * Dynamically renders the appropriate footer component
 * based on the current layout theme.
 */

import { useLayout } from "@/lib/layout-provider";
import FooterFull from "./FooterFull";
import FooterSimple from "./FooterSimple";
import FooterCentered from "./FooterCentered";
import FooterMinimal from "./FooterMinimal";
import type { FooterStyle } from "@/lib/layout-types";

const footerComponents: Record<FooterStyle, React.ComponentType> = {
  'full': FooterFull,
  'simple': FooterSimple,
  'centered': FooterCentered,
  'minimal': FooterMinimal,
};

const FooterSelector = () => {
  const { currentLayout } = useLayout();
  const FooterComponent = footerComponents[currentLayout.footer.style] || FooterFull;

  return <FooterComponent />;
};

export default FooterSelector;





